module.exports = __webpack_public_path__ + "img/instagram.ecd0303.png";